

import { Suspense } from "react";
import { useAuth } from "@/hooks/useAuth";
import DashboardLayout from "../components/DashboardLayout";
import { DashboardGrid } from "./components/DashboardGrid";
import { useNavigate } from "react-router-dom";

function DashboardPageContent() {
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();

  const handleGoToLogin = async () => {
    await logout(); // Clear session properly
    navigate("/login");
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-stone-50">
        <div className="flex flex-col items-center gap-4">
          <div className="animate-spin rounded-full h-12 w-12 border-2 border-amber-500 border-t-transparent"></div>
          <p className="text-stone-500 text-sm">Loading dashboard...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-stone-50">
        <div className="flex flex-col items-center gap-4">
          <h2 className="text-xl font-bold text-stone-800">Authentication Required</h2>
          <button 
            onClick={handleGoToLogin}
            className="mt-4 px-6 py-3 bg-amber-500 text-white rounded-lg hover:bg-amber-600 transition-colors"
          >
            Go to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <DashboardLayout>
      <div className="p-4 sm:p-6 lg:p-8">
        {/* Header */}
        <div className="mb-6 sm:mb-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <div>
            <h1 className="text-2xl sm:text-3xl font-bold text-stone-900">
              Welcome back, {user.name}!
            </h1>
            <p className="text-sm text-stone-500 mt-1">
              Here&apos;s your business overview
            </p>
          </div>
          <div className="flex items-center gap-2 text-xs text-stone-400 bg-stone-100 rounded-lg px-3 py-2 self-start sm:self-auto">
            <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse inline-block" />
            Live data
          </div>
        </div>

        {/* Dashboard Grid with Real-time Widgets */}
        <DashboardGrid />
      </div>

    </DashboardLayout>
  );
}

function LoadingFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-stone-50">
      <div className="flex flex-col items-center gap-4">
        <div className="animate-spin rounded-full h-12 w-12 border-2 border-amber-500 border-t-transparent"></div>
        <p className="text-stone-500 text-sm">Loading dashboard...</p>
      </div>
    </div>
  );
}

export default function DashboardPage() {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <DashboardPageContent />
    </Suspense>
  );
}
